export const LEAD_STATUSES = [
  "New",
  "Qualified",
  "Proposal Sent",
  "Negotiation",
  "Deal Confirmation",
  "Lost",
];